import * as React from 'react';
import Contracts from '../../components/Contracts/Contracts';

export default function ContractsPage(): React.ReactElement {
    return <Contracts/>;
}
